<template src="./hint-text.html"></template>

<script lang="ts">

const TYPES = ['alert', 'error', 'info']

export default {
  props: {
    type: {
      type: String,
      default: 'info',
      validator: (v: string) => TYPES.indexOf(v) > -1
    },
    text: { type: String }
  },
  computed: {
    iconName() {
      return this.type === 'alert' ? 'question' : this.type
    },
    hasValidType() {
      return TYPES.indexOf(this.type) > -1
    }
  }
}
</script>

<style lang="scss" src="./hint-text.scss"></style>
